<template>
	<div id="container">
		<div class="tabdate">
			<el-carousel type="card" height="56px" :autoplay="false" indicator-position="none" ref="carousel" arrow="always" @change="getIndex">
				<el-carousel-item v-for="(item,index) in dataList" :key="index" name="index">
					<h3>{{ item.date }}</h3>
				</el-carousel-item>
			</el-carousel>
			<span class="zuozhe"></span>
			<span class="youzhe"></span>
		</div>
	</div>
</template>

<script>
export default {
    props: ['currentObjectIndex', 'dataList'],
    data () {
        return {

        }
    },
    watch: {
        'currentObjectIndex' (newVal, oldVal) {
            this.setActive(newVal)
        }
    },
    mounted () {
        this.$nextTick(() => {
            this.setActive(this.currentObjectIndex)
        })
    },
    methods: {
        setActive (index) {
            this.$refs.carousel.setActiveItem(index)
        },
        getIndex (val) {
            this.$emit('currentIndex', val)
        }
    }
}
</script>

<style lang="scss">
	#container {
		/*日历*/
		/*签到表*/
		.wh_content_item {
			color: #333;
			cursor: pointer;
		}
		.wh_top_changge li {
			color: #333;
		}
		.wh_jiantou1,
		.wh_jiantou2 {
			border-color: #333;
		}
		.wh_content_all {
			background: #fff;
			margin-top: 15px;
		}
		.wh_isToday {
			background: #fff;
			border: 1px solid #0090FF;
		}
		.wh_chose_day {
			background: #0090FF;
		}
		.wh_content_item>.wh_isMark {
			background: #0090FF;
			color: #fff;
		}
		.tabdate {
			position: relative;
			width: 420px;
			margin: 0 auto;
			span {
				position: absolute;
				top: 0;
				height: 56px;
				width: 40px;
				background: #fff;
				z-index: 9999;
				&.zuozhe {
					left: 0;
				}
				&.youzhe {
					right: 0;
				}
			}
		}
		.el-carousel__item h3 {
			color: #475669;
			font-size: 18px;
			margin: 0;
			line-height: 56px;
			text-align: center;
		}
		.el-carousel__item:nth-child(2n) {
			background: rgba(0, 0, 0, 0);
		}
		.el-carousel__item:nth-child(2n+1) {
			background: rgba(0, 0, 0, 0);
		}
		.is-active h3 {
			font-size: 28px;
			color: #AD011B;
			width: auto;
		}
		.el-carousel__arrow {
			width: 20px;
			height: 36px;
			z-index: 99999;
		}
		.el-carousel__arrow--left {
			background: url(../images/zuo.png) no-repeat;
		}
		.el-carousel__arrow--right {
			background: url(../images/you.png) no-repeat;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/datecarousel.vue